import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  MenuItem,
  Grid,
  Tooltip,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const ResultForm = (props) => {
  const {
    investigations,
    investigationIndex,
    setInvestigations,
    isSubInvestigation,
    subInvestigationIndex,
    subInvestigationName,
    handleClose,
  } = props;

  const [results, setResults] = useState([{ value: 1 }]);

  useEffect(() => {
    const initialMethods = isSubInvestigation
      ? investigations[investigationIndex]?.subInvestigations[
          subInvestigationIndex
        ]?.results || []
      : investigations[investigationIndex]?.results || [];
    setResults(initialMethods);
  }, []);

  const handleAddResult = () => {
    setResults((prevResults) => [...prevResults, { value: "" }]);
  };

  const handleRemoveResultResults = (resultIndex) => {
    setResults((prevResults) => {
      const updatedResults = [...prevResults];
      updatedResults.splice(resultIndex, 1);
      setInvestigations((prevInvestigations) => {
        const updatedInvestigations = [...prevInvestigations];
        if (isSubInvestigation) {
          updatedInvestigations[investigationIndex].subInvestigations[
            subInvestigationIndex
          ].results = updatedResults;
        } else {
          updatedInvestigations[investigationIndex].results = updatedResults;
        }
        return updatedInvestigations;
      });
      return updatedResults;
    });
  };

  const handleResultChange = (e, index) => {
    const updatedResults = [...results];
    updatedResults[index] = { value: e.target.value };
    setResults(updatedResults);

    const updatedInvestigations = [...investigations];
    if (isSubInvestigation) {
      updatedInvestigations[investigationIndex].subInvestigations[
        subInvestigationIndex
      ].results = updatedResults;
    } else {
      updatedInvestigations[investigationIndex].results = updatedResults;
    }
    setInvestigations(updatedInvestigations);
  };

  return (
    <Box sx={{ margin: "auto", padding: "20px" }}>
      <Grid container spacing={1}>
        {results.map((result, resultIndex) => (
          <Grid item xs={6} lg={6} sx={{ position: "relative" }}>
            <TextField
              key={resultIndex}
              label="Results"
              type="text"
              size="small"
              value={result.value}
              onChange={(e) => handleResultChange(e, resultIndex)}
              fullWidth
            />
            <Tooltip title="remove result" placement="top">
              <DeleteIcon
                onClick={() => handleRemoveResultResults(resultIndex)}
                sx={{
                  position: "absolute",
                  top: "6px",
                  right: "-10px",
                  cursor: "pointer",
                  color: "red",
                }}
              />
            </Tooltip>
          </Grid>
        ))}
        <Grid item xs={6}>
          <AddCircleOutlineIcon
            color="success"
            onClick={handleAddResult}
            sx={{ marginRight: 2 }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ResultForm;
